<template>
  <div class='container-fluid'>
    <div class='form-row'>
      <div class='col-12 col-sm-6 order-sm-1'>
        <div class='row no-gutters'>
          <div class='col'>
            <label for='oldestTraveller_dob'>{{$t('text.page3_input2b')}} <span class='requiredText' aria-hidden='true'>*</span><br/>{{$t('text.dateofbirthformat')}}</label>
          </div>
          <div class='col-auto'>
            <button v-if='this.$store.state.site==="cibc"' class="moreHelp" @click="openTooltip($t('text.page3_input2_tooltip')+$t('text.contactSnippet'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input2b')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
            <button v-else class="moreHelp" @click="openTooltip($t('text.page3_input2_tooltipnm')+$t('text.contactSnippetnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input2b')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
          </div>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-3'>
        <Datepicker id='oldestTraveller_dob' 
          v-model='oldestTraveller_dob'
          :flow="['year', 'month', 'day']"
          :startDate="date30YearsAgo"
          :disabled-dates="date15DaysAgo"
          :day-class="() => ''"
          :start-view="'year'"
          model-type="format"
          :typeable="true"
          :auto-apply="true"
          :enable-time-picker="false"
          :text-input="{
            format: ['MM/dd/yyyy'],
            tabSubmit: true,
            openMenu: true
          }"
          input-class='form-control' 
          :placeholder='$t("text.datePlaceholder")'
          :locale="getLocale()"
          :format="'MM/dd/yyyy'"
          aria-required='true'></Datepicker>

        <input style='display:none;' v-model='oldestTraveller' class='form-control' type='number' id='oldestTraveller' name="oldestTraveller" :placeholder="$t('text.page3_input2placeholder')" aria-describedby='err_oldestTraveller' aria-required='true'>
      </div>
      <div class='col-12 col-sm-6 order-sm-5'>
          <span for='oldestTraveller_dob' class='feedback' id='err_oldestTraveller_dob' tabindex="-1"></span>
      </div>
      <div class='col-12 col-sm-6 order-sm-2'>
        <div class='row'>
          <div class='col'>
            <label v-if='oldestTraveller>59' id='lbl_numberOfTravellers' for='numberOfTravellers' v-html='$t("text.page3_input1b")'></label>
            <label v-else id='lbl_numberOfTravellers' for='numberOfTravellers' v-html='$t("text.page3_input1")'></label>
          </div>
          <div class='col-auto'>
            <button v-if="this.$store.state.site==='cibc'" class="moreHelp" @click="openTooltip($t('text.page3_input1_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input1')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
            <button v-else class="moreHelp" @click="openTooltip($t('text.page3_input1_tooltipnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input1')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
          </div>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-4'>
        <select v-model='numberOfTravellers' class='form-control' id='numberOfTravellers' aria-required="true">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
        </select>
      </div>
      <div class='col-12 col-sm-6 order-sm-6'>
      </div>
    </div>

    <div class='form-row'>
      <div class='col-12 col-sm-6 order-sm-1'>
        <div class='row'>
          <div class='col'>
            <label v-if='this.$store.state.wantsCancellation===true' for='tripCost' >{{$t('text.page3_input5')}} <span class='requiredText' aria-hidden='true'>*</span></label>
            <label v-else for='tripCost' >{{$t('text.page3_input5')}} ({{$t('text.optional')}})</label>
          </div>
          <div class='col-auto'>
            <div v-if='this.$store.state.site==="cibc"'>
              <button v-if='this.$store.state.wantsCancellation===true' class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
              <button v-else class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltipoptional')+' '+$t('text.page3_input5_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
            </div>
            <div v-else>
              <button v-if='this.$store.state.wantsCancellation===true' class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltipnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
              <button v-else class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltipoptional')+' '+$t('text.page3_input5_tooltipnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-3'>
        <div class='input-group'>
          <div class='input-group-prepend'>
            <span class='input-group-text' style='width: 35px;'>$</span>
          </div>
          <input v-if='this.$store.state.wantsCancellation===true' v-model='tripCost' type="number" class='form-control' id='tripCost' placeholder="0" aria-required="true" aria-describedby='err_tripCost'/>
          <input v-else v-model='tripCost' type="number" class='form-control' id='tripCost' placeholder="0" aria-required="false" aria-describedby='err_tripCost'/>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-5'>
        <span for='tripCost' class='feedback' id='err_tripCost' tabindex="-1"></span>
      </div>
      <div class='col-12 col-sm-6 order-sm-2'>
        <label for='province'>{{$t('text.page3_input6')}} <span class='requiredText' aria-hidden='true'>*</span></label>
      </div>
      <div class='col-12 col-sm-6 order-sm-4'>
        <select v-model='province' class='form-control' id="province" name="province" aria-required="true" aria-describedby='err_province'>
          <option value="" disabled selected>{{$t("text.select")}}</option>
          <option :value='$t("text.prov1v")'>{{$t("text.prov1")}}</option>
          <option v-if='!(this.$store.state.site!="cibc"&&showBC===false)' :value='$t("text.prov2v")'>{{$t("text.prov2")}}</option>
          <option :value='$t("text.prov3v")'>{{$t("text.prov3")}}</option>
          <option :value='$t("text.prov4v")'>{{$t("text.prov4")}}</option>
          <option :value='$t("text.prov5v")'>{{$t("text.prov5")}}</option>
          <option :value='$t("text.prov6v")'>{{$t("text.prov6")}}</option>
          <option :value='$t("text.prov7v")'>{{$t("text.prov7")}}</option>
          <option :value='$t("text.prov8v")'>{{$t("text.prov8")}}</option>
          <option v-if='!(this.$store.state.site!="cibc"&&this.$i18n.locale==="fr")' :value='$t("text.prov9v")'>{{$t("text.prov9")}}</option>
          <option :value='$t("text.prov10v")'>{{$t("text.prov10")}}</option>
          <option v-if='!(this.$store.state.site!="cibc"&&this.$i18n.locale==="en")' :value='$t("text.prov11v")'>{{$t("text.prov11")}}</option>
          <option :value='$t("text.prov12v")'>{{$t("text.prov12")}}</option>
          <option :value='$t("text.prov13v")'>{{$t("text.prov13")}}</option>
        </select> 
      </div>
      <div class='col-12 col-sm-6 order-sm-6'>
        <span for='province' class='feedback' id='err_province' tabindex="-1"></span>
      </div>
    </div>

    <div class='form-row'>
      <div class='col-12 col-sm-6 order-sm-1'>
            <label for='departureDate'>{{$t('text.page3_input3')}} <span class='requiredText' aria-hidden='true'>*</span><br/>{{$t('text.dateofbirthformat')}}</label>
      </div>
      <div class='col-12 col-sm-6 order-sm-3'>
        <datepicker id='departureDate' 
          v-model='departureDate'
          :placeholder='$t("text.datePlaceholder")'
          model-type="format"
          input-class='form-control'
          :day-class="() => ''"
          :locale="getLocale()"
          :disabled-dates="disabledTripDates"
          :typeable="true"
          :auto-apply="true"
          :enable-time-picker="false"
          :text-input="{
            format: ['MM/dd/yyyy'],
            tabSubmit: true,
            openMenu: true
          }"
          aria-required="true" ></datepicker>
      </div>
      <div class='col-12 col-sm-6 order-sm-5'>
          <span for='departureDate' class='feedback' id='err_departureDate' tabindex="-1"></span>
      </div>
      <div class='col-12 col-sm-6 order-sm-2'>
            <label for='returnDate'>{{$t('text.page3_input4')}} <span class='requiredText' aria-hidden='true'>*</span><br/>{{$t('text.dateofbirthformat')}}</label>
      </div>
      <div class='col-12 col-sm-6 order-sm-4'>
        <datepicker id='returnDate'
          v-model='returnDate'
          model-type="format"
          input-class='form-control'
          :placeholder='$t("text.datePlaceholder")'
          :day-class="() => ''"
          :locale="getLocale()"
          :disabled-dates="disabledTripDates"
          :typeable="true"
          :auto-apply="true"
          :enable-time-picker="false"
          :text-input="{
            format: ['MM/dd/yyyy'],
            tabSubmit: true,
            openMenu: true
          }"
          aria-required="true"></datepicker>
      </div>
      <div class='col-12 col-sm-6 order-sm-6'>
          <span for='returnDate' class='feedback' id='err_returnDate' tabindex="-1"></span>
      </div>
    </div>

    <div style='display:none;'>
      <input id='wantsCancellation' type='checkbox' v-model='wantsCancellation'>
    </div>
  </div>
</template>

<script>
import getLocale from "../utils/getLocale";
import { addNavProceedCheck, updateNavProceed } from "../utils/navProceed.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField, callValidationStatusOnBlur } from "../utils/validation.js";
import { validateDepartureDate, validateReturnDate, validateOldestTraveller, validateTripCost } from "../utils/validation_custom.js";
import { validateBirthDate } from "../utils/validation_custom.js";
import bus from "../utils/bus.js";
import generalConfig from "../config/generalConfig.js";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';



export default {
  components: {
    Datepicker: VueDatePicker
  },
  data() {
    const date30YearsAgo = new Date();
    date30YearsAgo.setDate(date30YearsAgo.getDate() - (365*30));
    
    return {
      date30YearsAgo
    };
  },
  computed: {
    showBC: {
      get() {
        const gc = generalConfig();
        return this.$moment().isSameOrAfter(gc.showBCAfter);
      }
    },
    oldestTraveller_dob: {
      get() {
        return this.$store.state.oldestTraveller_dob;
      },
      set(newValue) {
        const normalizedValue = this.normalizeDateInput(newValue);
        this.$store.commit("setOldestTravellerDob", normalizedValue);
        this.setDateOfBirth("oldestTraveller_dob", normalizedValue);
      }
    },
    numberOfTravellers: {
      get() {
        return this.$store.state.numberOfTravellers;
      },
      set(newValue){
        const normalized = `${newValue ?? ""}`.trim() || "1";
        this.$store.commit("setNumberOfTravellers", normalized);
        this.$nextTick(() => {
          const navTargets = this.getTravelPlanNavTargets();
          if (navTargets.length) {
            updateNavProceed(navTargets);
          }
        });
      }
    },
    oldestTraveller: {
      get() {
        return this.$store.state.oldestTraveller;
      },
      set(newValue) {
        const oldestTravellerEl = document.getElementById("oldestTraveller");
        if (oldestTravellerEl && validateField(oldestTravellerEl, newValue, validationRules())){
          validateOldestTraveller(newValue, this.$store.state.wantsMedical, this.$store.state.site);
        }
      }
    },
    departureDate: {
      get() {
        return this.$store.state.departureDate;
      },
      set(newValue) {
        const normalizedValue = this.normalizeDateInput(newValue);
        this.$store.commit("setDepartureDate", normalizedValue);
        this.setDatepickerDomValue("departureDate", normalizedValue);
        const { input, root } = this.getDatepickerElements("departureDate");
        const departureDateEl = input ?? root;
        if (departureDateEl) {
          //departureDateEl.classList.add("is-valid");
          departureDateEl.classList.remove("is-invalid");
          if (validateField(departureDateEl, normalizedValue, validationRules())) {
            const oldestTravellerDobValue = this.$store.state.oldestTraveller_dob || this.getDatepickerValue("oldestTraveller_dob");

            if(validateDepartureDate(new Date(normalizedValue))===true){
              this.calculateOldestTraveller(oldestTravellerDobValue, normalizedValue);
            }
            else {
              this.calculateOldestTraveller(oldestTravellerDobValue, this.$moment().format("MM/DD/YYYY"));
            }

            const returnDateValue = this.getDatepickerValue("returnDate");
            if(returnDateValue){
              validateReturnDate(
                new Date(returnDateValue),
                new Date(normalizedValue)
              );
            }
          }

          const navTargets = departureDateEl.targets ?? this.getTravelPlanNavTargets();
          if (navTargets && navTargets.length) {
            updateNavProceed(navTargets);
          }
        }
      }
    },
    returnDate: {
      get() {
        return this.$store.state.returnDate;
      },
      set(newValue) {
        const normalizedValue = this.normalizeDateInput(newValue);
        this.$store.commit("setReturnDate", normalizedValue);
        this.setDatepickerDomValue("returnDate", normalizedValue);
        const { input, root } = this.getDatepickerElements("returnDate");
        const returnDateEl = input ?? root;
        if (returnDateEl) {
          //returnDateEl.classList.add("is-valid");
          returnDateEl.classList.remove("is-invalid");
          if (validateField(returnDateEl, normalizedValue, validationRules())) {
            validateReturnDate(new Date(normalizedValue));
            const departureDateValue = this.getDatepickerValue("departureDate");
            if (departureDateValue) {
              validateDepartureDate(
                new Date(departureDateValue),
                new Date(normalizedValue)
              );
            }
          }
          const navTargets = returnDateEl.targets ?? this.getTravelPlanNavTargets();
          if (navTargets && navTargets.length) {
            updateNavProceed(navTargets);
          }
        }
      }
    },
    tripCost: {
      get() {
        return this.$store.state.tripCost;
      },
      set(newValue) {
        this.$store.commit("setTripCost", newValue);
        const tripCostEl = document.getElementById("tripCost");
        if (tripCostEl && validateField(tripCostEl, newValue, validationRules())){
          validateTripCost(this.$store.state.site,newValue);
        }
      }
    },
    province: {
      get() {
        return this.$store.state.province;
      },
      set(newValue) {
        this.$store.commit("setProvince", newValue);
        const provinceEl = document.getElementById("province");
        if (provinceEl) {
          validateField(provinceEl, newValue, validationRules());
        }
        const departureDateValue = this.getDatepickerValue("departureDate");
        const returnDateValue = this.getDatepickerValue("returnDate");
        if(departureDateValue && returnDateValue){
          validateReturnDate();
        }
        const navTargets = this.getTravelPlanNavTargets();
        if (navTargets.length) {
          updateNavProceed(navTargets);
        }
      }
    },
    wantsCancellation: {
      get() {
        return this.$store.state.wantsCancellation;
      }
    }
  },
  methods:{
    normalizeDateInput(value) {
      if (!value) return "";
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return this.$moment(value).format("MM/DD/YYYY");
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return "";
        const parsed = this.$moment(trimmed);
        return parsed.isValid() ? parsed.format("MM/DD/YYYY") : trimmed;
      }
      return "";
    },
    syncNumberOfTravellers() {
      const select = document.getElementById("numberOfTravellers");
      const rawValue = select && typeof select.value === "string" ? select.value : "";
      const normalized = rawValue.trim() || "1";
      this.$store.commit("setNumberOfTravellers", normalized);
    },
    getDatepickerElements(fieldId) {
      const root = document.getElementById(fieldId) || null;
      const input = root ? root.querySelector("input.dp__input") : null;
      if (input && input.id !== fieldId) {
        input.id = fieldId;
      }
      return { root, input };
    },
    getDatepickerValue(fieldId) {
      const { root, input } = this.getDatepickerElements(fieldId);
      if (input && typeof input.value === "string") {
        return input.value;
      }
      if (root && typeof root.value === "string") {
        return root.value;
      }
      return "";
    },
    setDatepickerDomValue(fieldId, value) {
      const normalized = value ?? "";
      const { root, input } = this.getDatepickerElements(fieldId);
      if (root && typeof root.value === "string") {
        root.value = normalized;
      }
      if (input) {
        input.value = normalized;
      }
    },
    getTravelPlanNavTargets() {
      const { input: oldestTravellerInput } = this.getDatepickerElements("oldestTraveller_dob");
      const { input: departureDateInput } = this.getDatepickerElements("departureDate");
      const { input: returnDateInput } = this.getDatepickerElements("returnDate");
      const provinceEl = document.getElementById("province");
      return [oldestTravellerInput, departureDateInput, returnDateInput, provinceEl].filter(Boolean);
    },
    getLocale,
   
    openTooltip(text) {
      const keywordBody = document.getElementById("keywordBody");
      if (keywordBody) {
        keywordBody.innerHTML = text;
        this.$nextTick(() => {
          keywordBody.focus();
        });
      }
      bus.$emit("openModal");
    },
    setDateOfBirth(targetField, newValue) {
      const normalizedValue = this.normalizeDateInput(newValue);
      this.setDatepickerDomValue(targetField, normalizedValue);
      const { input, root } = this.getDatepickerElements(targetField);
      const targetInput = input ?? root;
      if (targetInput) {
        targetInput.classList.remove("is-invalid");
        //targetInput.classList.add("is-valid");
        if (validateField(targetInput, normalizedValue, validationRules())) {
          validateBirthDate(targetInput, normalizedValue, this.$store.state.wantsMedical);
        }
      }
      const navTargets = (targetInput && targetInput.targets) ? targetInput.targets : this.getTravelPlanNavTargets();
      if (navTargets && navTargets.length) {
        updateNavProceed(navTargets);
      }
      const departureValue = this.$store.state.departureDate || this.getDatepickerValue("departureDate");
      this.calculateOldestTraveller(normalizedValue, departureValue);
    },
    calculateOldestTraveller(oldestTravellerDoB, departureDate){
      let oldestTraveller = 0;
      let calculationDate = this.$moment().format("MM/DD/YYYY");
      if(departureDate){
        const parsedDeparture = this.$moment(departureDate,"MM/DD/YYYY");
        if(parsedDeparture.isValid()){
          calculationDate = parsedDeparture.format("MM/DD/YYYY");
        }
      }
      const oldestTravellerMoment = this.$moment(oldestTravellerDoB,"MM/DD/YYYY");
      const age = oldestTravellerMoment.isValid()
        ? this.$moment(calculationDate,"MM/DD/YYYY").diff(oldestTravellerMoment, "years", false)
        : 0;
      if(age>oldestTraveller) {
        oldestTraveller=age;
      }
      else {
        const fallbackDob = this.$store.state.oldestTraveller_dob || this.getDatepickerValue("oldestTraveller_dob");
        const fallbackMoment = this.$moment(fallbackDob,"MM/DD/YYYY");
        oldestTraveller = fallbackMoment.isValid()
          ? this.$moment().diff(fallbackMoment, "years", false)
          : 0;
      }
      const oldestTravellerInput = document.getElementById("oldestTraveller");
      if (oldestTravellerInput) {
        if (validateField(oldestTravellerInput, oldestTravellerDoB, validationRules())){
          validateOldestTraveller(oldestTraveller, this.$store.state.wantsMedical, this.$store.state.site);
        }
        oldestTravellerInput.value = `${oldestTraveller}`;
      }
      this.$store.commit("updateOldestTraveller", `${oldestTraveller}`);
      this.syncNumberOfTravellers();
    },
    date15DaysAgo(date) { 
      const today = new Date();
      const minDate = new Date();
      minDate.setDate(minDate.getDate() - 15);
      return date > today || date > minDate;
    },
    disabledTripDates(date){
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today; 
    }

  },
  mounted() {
    document.getElementById("stepTitleAppend").innerHTML="";
    
    if(this.$store.state.policyNumber!=""){location.reload();}
    
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    validateOldestTraveller(this.$store.state.oldestTraveller, this.$store.state.wantsMedical, this.$store.state.site);
    if(document.getElementById("tripCost").value>"0") {
      validateTripCost(this.$store.state.site);
    }
    const departureDateValue = this.getDatepickerValue("departureDate");
    const returnDateValue = this.getDatepickerValue("returnDate");
    if(departureDateValue!=="" && returnDateValue!==""){
      validateDepartureDate();
      validateReturnDate();
    }

    this.syncNumberOfTravellers();

    const { input: oldestTravellerInput } = this.getDatepickerElements("oldestTraveller_dob");
    if (oldestTravellerInput) {
      oldestTravellerInput.setAttribute("aria-required","true");
      oldestTravellerInput.setAttribute("aria-describedby","err_oldestTraveller_dob");
    }
    const { input: departureInput } = this.getDatepickerElements("departureDate");
    if (departureInput) {
      departureInput.setAttribute("aria-required","true");
      departureInput.setAttribute("aria-describedby","err_departureDate");
    }
    const { input: returnInput } = this.getDatepickerElements("returnDate");
    if (returnInput) {
      returnInput.setAttribute("aria-required","true");
      returnInput.setAttribute("aria-describedby","err_returnDate");
    }

    if (typeof Object.assign !== "function") {
      Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) {
          "use strict";
          if (target == null) {
            throw new TypeError("Cannot convert undefined or null to object");
          }
          const to = Object(target);
          for (let index = 1; index < arguments.length; index++) {
            const nextSource = arguments[index];

            if (nextSource !== null) {
              for (const nextKey in nextSource) {
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
          return to;
        },
        writable: true,
        configurable: true
      });
    }

    callValidationStatusOnBlur(validationRules());

    const navTargets = this.getTravelPlanNavTargets();
    this.$nextTick( () => {
      if (navTargets.length) {
        addNavProceedCheck(navTargets);
      }
    });
  }
};
</script>

